import React from 'react';
import { logError } from '../../service/ErrorService';
import logo from '../leftnav/ppm-logo.png';
import errorSvg from '../../images/error.svg';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // TODO: Integrate api call to system logging service - story 131042
        // response should be 204 - success, no content
        logError({error, errorInfo}, this.logHandler);
    }

    logHandler(success, response) {
        if (success) {
            console.log("Error successfully logged");
        } else {
            console.log("Unable to log error", response);
        }
    }

    render() {
        if (this.state.hasError || this.props.testError) {  //testError is only used in unit test file
            return (
                <div className="d-flex" id="wrapper">
                    <div className="border-end" id="sidebar-wrapper">
                        <div>
                            <div className="sidebar-heading"><img src={logo} alt="Payment Portal Logo" /></div>
                            <nav className="nav">{/* empty nav container needed for rendering below 990px widths */}</nav>
                        </div>
                    </div>
                    <div id="page-content-wrapper">
                        <div id="error-content" data-testid="error-content">
                            <div className="bubble"><img src={errorSvg} alt="error" /></div>

                            <p>Sorry, an unexpected error occurred and the page is temporarily unavailable.
                            If the error persists, please contact your Commerce Support Team.</p>
                            <a href="/company/default/dashboard">Go to Dashboard</a>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;